/* eslint-disable no-console */

export function logDevDebug(...args: unknown[]): void {
  if (process.env.NODE_ENV !== "production") {
    console.debug(...args);
  }
}

export function logDevWarn(...args: unknown[]): void {
  if (process.env.NODE_ENV !== "production") {
    console.warn(...args);
  }
}

export function logDevError(...args: unknown[]): void {
  if (process.env.NODE_ENV !== "production") {
    console.error(...args);
  }
}
